import {getBeginLocalStr, getBeginStr, getEndLocalStr, getEndStr} from "../../../core/utils/date-utils";

/**
 * Çekim grid filtresini sunucuya gönderilecek hale getirir.
 *
 * TEK KAYNAK: grid ve sayaç bu fonksiyondan geçer; filtreyi sunucuya taşıyan yeni bir yer
 * (Excel, toplu işlem vb.) eklenirse o da buradan geçmeli. Rapor grid'inde Excel bu adımı
 * atladığı için grid ile Excel farklı sayı üretiyordu (bkz. report-filter-query).
 *
 * Geliş tarihi UTC'ye çevrilir; DICOM çekim tarihi sunucuda duvar saati olduğu için kaydırılmaz
 * (bkz. date-utils).
 */
export const normalizeStudyFilter = (filter) => ({
    ...filter,
    studyReceivedDateTimeBegin: getBeginStr(filter?.studyReceivedDateTimeBegin),
    studyReceivedDateTimeEnd: getEndStr(filter?.studyReceivedDateTimeEnd),
    studyDateTimeBegin: getBeginLocalStr(filter?.studyDateTimeBegin),
    studyDateTimeEnd: getEndLocalStr(filter?.studyDateTimeEnd),
    patientIdList: (filter?.patientId || '').split(/[\s,]+/).map(x => x.trim()).filter(Boolean),
    // Liste filtresi ZORUNLU olarak null'lanır: sunucuda "boş dizi = imkânsız sonuç" semantiği var
    // (görmediği listeyle filtreleyen kullanıcı her şeyi görmesin diye). Seçim temizlenince antd
    // [] gönderir; olduğu gibi gitseydi grid boş kalırdı.
    listIdList: (filter?.listIdList && filter.listIdList.length > 0) ? filter.listIdList : null,
});
